export default function QuotationFooter({ generatedBy = '' }) {
  return (
    <div className="mt-10">
      {/* Signature Section */}
      <div className="mb-10 flex items-start justify-between">
        <div>
          <p className="text-base">
            <span className="font-semibold">Generated by:</span>{' '}
            {generatedBy || '-'}
          </p>
        </div>
      </div>

      {/* Company Footer */}
      <div className="border-t-[3px] border-yellow-500 pt-3 text-center text-xs leading-5 text-gray-600 ">
        <p className="font-semibold text-gray-800">
          Superior Digital Private Limited
        </p>

        <p>#111, 6th Main Road, MRCR Layout, Vijayanagar, Bangalore - 560040</p>

        <p>GSTIN : 29AAYCS0407L1ZQ &nbsp; | &nbsp; PAN : AAYCS0407L</p>

        <p>
          Phone : 080-23116047 &nbsp; | &nbsp; Email : sales@superiorsystems.in
        </p>
      </div>
    </div>
  )
}
